import * as LiveActions from 'actions/Live';
import * as LineActions from 'actions/Line';
import * as TimeTableActions from 'actions/Timetable';

export default function showLineNumbersReducer(flag, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case LineActions.CLEAR_LINE:
        case TimeTableActions.CLEAR_TIME_TABLE:
        case LineActions.HIDE_LINE_NUMBERS:
            return false;

        case LineActions.SHOW_LINE_NUMBERS:
            return true;
    }

    return flag;
}


// WEBPACK FOOTER //
// ./js/shared/reducers/entities/showLineNumbersReducer.js